import { useSyncExternalStore } from 'react';

/** Two months need roughly 560px of viewport once the popover has padding. */
const TWO_MONTH_MIN_WIDTH = 640;

const query = `(min-width: ${TWO_MONTH_MIN_WIDTH}px)`;

const subscribe = (onChange: () => void) => {
  const mql = window.matchMedia(query);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
};

/**
 * How many months a range calendar may show. The popover is portalled, so it is
 * not bound by its trigger's column — only by the viewport.
 */
export function useCalendarMonths(preferred: number): number {
  const fits = useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => true,
  );

  return fits ? preferred : 1;
}
